<template>
    <div class="row">
        <div class="col-12 col-lg-10 offset-lg-1">
            <a href="#" target="_self" class="content-video">
            <div class="content-video--video">
                <!-- Capturar ID do vídeo e trocar por jNQXAC9IVRw -->
                <iframe
                allowFullScreen="allowFullScreen"
                :src="'https://www.youtube.com/embed/'+value.video.video_id+'?ecver=1&amp;iv_load_policy=3&amp;rel=0&amp;showinfo=0&amp;yt:stretch=16:9&amp;autohide=1&amp;color=red&amp;width=560&amp;width=560'"
                width="100%"
                height="450"
                allowtransparency="true"
                frameborder="0">
                </iframe>
            </div>
            </a>
        </div>
    </div>
</template>

<script>
export default {
    name: 'Video',
    props:['value'],
}
</script>